import { defineMessages } from 'react-intl';

export default defineMessages({
    addPerson: {
        id: '_.person.title',
        defaultMessage: 'Add a person'
    },
    editPerson: {
        id: '_.edit_person.title',
        defaultMessage: 'Edit {name} details'
    },
    fullName: {
        id: '_.person.full_name',
        defaultMessage: 'Full name'
    },
    dateOfBirth: {
        id: '_.person.date_of_birth',
        defaultMessage: 'Date of birth'
    },
    roleTitle: {
        id: '_.person.role_title',
        defaultMessage: 'This person is a...'
    },
    privacyPolicy: {
        id: '_.person.privacy_policy',
        defaultMessage:
            "I've shared the iwoca {privacyPolicyLink} with this person and they understand that their personal information will be used to run quotation searches with credit reference agencies, as well as fraud prevention agencies."
    },
    privacyPolicyLink: {
        id: '_.person.privacy_policy_link',
        defaultMessage: 'privacy policy'
    },
    contactToolTip: {
        id: '_.person.tooltip_message',
        defaultMessage: 'Contact your account manager to change this'
    },
    contactDetails: {
        id: '_.person.contact_details',
        defaultMessage: 'Contact details'
    },
    email: {
        id: '_.person.email',
        defaultMessage: 'Email address'
    },
    marketing: {
        id: '_.person.marketing',
        defaultMessage: 'News and updates from iwoca'
    },
    phone: {
        id: '_.person.phone',
        defaultMessage: 'Phone number'
    },
    addressDetails: {
        id: '_.person.address_details',
        defaultMessage: 'Address details'
    },
    homeAddress: {
        id: '_.person.home_address',
        defaultMessage: 'Home address'
    },
    residentialStatus: {
        id: '_.person.residential_status',
        defaultMessage: 'Residential status'
    },
    residentialStatusPlaceholder: {
        id: '_.person.residential_status_placeholder',
        defaultMessage: 'Select residential status...'
    },
    validNameRequired: {
        id: '_.person.error.valid_name_required',
        defaultMessage: 'Please enter a valid name'
    },
    validDateOfBirthRequired: {
        id: '_.person.error.valid_date_of_birth_required',
        defaultMessage: 'Please enter a valid date of birth'
    },
    emailAddressRequired: {
        id: '_.person.error.email_address_required',
        defaultMessage: 'Please enter an email address'
    },
    phoneNumberRequired: {
        id: '_.person.error.phone_number_required',
        defaultMessage: 'Please enter at least one phone number'
    },
    addressRequired: {
        id: '_.person.error.address_required',
        defaultMessage: 'Please enter at least one address'
    },
    streetLineOneRequired: {
        id: '_.person.error.street_line_one_required',
        defaultMessage: 'Please enter a street name'
    },
    postcodeRequired: {
        id: '_.person.error.postcode_required',
        defaultMessage: 'Please enter a postcode'
    },
    townRequired: {
        id: '_.person.error.town_required',
        defaultMessage: 'Please enter a town'
    },
    residentialStatusRequired: {
        id: '_.person.error.residential_status_required',
        defaultMessage: 'Please enter a residential status'
    },
    differentPhoneNumberRequired: {
        id: '_.person.error.different_phone_number_required',
        defaultMessage: 'Phone number cannot be the same as other guarantors'
    },
    differentEmailRequired: {
        id: '_.person.error.different_email_required',
        defaultMessage: 'Email cannot be the same as other guarantors'
    },
    consentForAdditionalGuarantorRequired: {
        id: '_.person.error.consent_for_additional_guarantor_required',
        defaultMessage: 'Consent required'
    },
    addAnotherPhoneNumber: {
        id: '_.person.add_another_phone_number',
        defaultMessage: 'Add another phone number'
    },
    addAnotherAddress: {
        id: '_.person.add_another_address',
        defaultMessage: 'Add previous address'
    },
    previousAddress: {
        id: '_.person.previous_address',
        defaultMessage: 'Previous address'
    },
    deletePerson: {
        id: '_.person.delete_person',
        defaultMessage: 'Remove {name}'
    },
    deleteConfirmation: {
        id: '_.person.delete_confirmation',
        defaultMessage: 'Are you sure?'
    },
    confirmAction: {
        id: '_.person.confirm_delete',
        defaultMessage: 'Yes'
    },
    cancelAction: {
        id: '_.person.cancel_delete',
        defaultMessage: 'No'
    }
});
